/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {HttpParams} from '@angular/common/http';

/**
 * Generate HttpParams from object
 * @param params Query params
 * @returns HttpParams object with query params
 */
const generateParamsFromObject = (params: any): HttpParams => {
  let httpParams = new HttpParams();
  for (let key in params) {
    if (
      params.hasOwnProperty(key) &&
      params[key] !== null &&
      params[key] !== undefined &&
      params[key] !== ''
    ) {
      if (Array.isArray(params[key])) {
        params[key].forEach((subObj: any) => {
          for (const subKey in subObj) {
            if (
              subObj.hasOwnProperty(subKey) &&
              subObj[subKey] !== null &&
              subObj[subKey] !== undefined &&
              subObj[subKey] !== ''
            ) {
              httpParams = httpParams.append(key, subObj[subKey]);
            }
          }
        });
      } else {
        httpParams = httpParams.set(key, params[key]);
      }
    }
  }
  return httpParams;
};

export const HttpUtils = {
  generateParamsFromObject,
};
